import React from 'react';

interface FormControlProps {
  children: React.ReactNode;
  error?: string;
  label: string;
  required?: boolean;
}

export const FormControl: React.FC<FormControlProps> = ({children, error, label, required = false}) => (
  <div className="space-y-1">
    <label className="block text-sm font-medium text-gray-700">
      {label}
      {required && <span className="text-red-500 ml-0.5">*</span>}
    </label>
    {children}
    {error && <p className="text-sm text-red-500">{error}</p>}
  </div>
);
